// AI GENERATED
import Skeleton from "react-loading-skeleton";

export default function Loading() {
  const avatarSize = 64; // Set a standard size for the circular avatar

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        maxWidth: "300px",
        padding: "10px",
        paddingInlineStart: 0,
      }}
    >
      {/* 1. Avatar Skeleton (Circular) */}
      <div style={{ marginRight: "10px" }}>
        <Skeleton circle height={avatarSize} width={avatarSize} />
      </div>

      {/* 2. Text Content Block (Title and Date/Metadata) */}
      <div style={{ flexGrow: 1 }}>
        {/* Title/Name Skeleton ("Черноголовый щегол") */}
        <div style={{ marginBottom: "4px" }}>
          {/* This is the main, bolder text line */}
          <Skeleton height={20} width="85%" />
        </div>

        {/* Date/Metadata Skeleton ("9 сент. 2025 г., 12:42") */}
        <div>
          {/* This is the secondary, less prominent line */}
          <Skeleton height={14} width="55%" />
        </div>
      </div>
    </div>
  );
}
